import React, {useContext} from 'react';

export interface BankDataPageTranslations {
  pageTitle: {
    default: string;
    form: string;
  };
  successToastMessage: string;
  errorToastMessage: string;
}

const BankDataPageTranslationContext =
  React.createContext<BankDataPageTranslations>({
    pageTitle: {
      default: '',
      form: '',
    },
    successToastMessage: '',
    errorToastMessage: '',
  });

export const useBankDataPageTranslationContext = () =>
  useContext(BankDataPageTranslationContext);

export default BankDataPageTranslationContext;
